import CommunityTalkForm from "@/pages/CommunityTalkForm";

export default function ExperienceForm() {
  return <CommunityTalkForm intent="experience" />;
}
